import React from 'react'
import './style/abous.css'
export default function AboutAs() {
  return (
    <div className="aboutA">
      <div className="a_left">
        <div className="al_top">
          <p>商务合作</p>
          <span>
            Email:
            <br />
            support@sitename.com
          </span>
        </div>
        <div className="al_bottom">
          <p>空特客服</p>
          <span>
            Email:
            <br />
            support@sitename.com
          </span>
        </div>
      </div>
      <div className="a_rigth">
        <p>空特下载站简介</p>
        <span>
          &nbsp;&nbsp;空特下载站是软件在线下载平台，一直致力于为国内外用户提供安全、稳定、全面、高速的免费下载服务；网站紧跟时代潮流，不断结合用户的真实需求，提升网站的用户体验，努力将网站打造成集软件下载、正版软件分发、高质量内容产生等多维一体的下载生态，让更多的用户可以快速准确便捷的找到自己的目标内容，满足用户的核心需求。
        </span>
      </div>
    </div>
  )
}
